module.exports = "#version 300 es\nprecision highp float;\n\nuniform vec2 u_PlanePos; // Our location in the virtual world displayed by the plane\n\nin vec3 fs_Pos;\nin vec4 fs_Nor;\nin vec4 fs_Col;\n\n\nout vec4 out_Col; // This is the final output color that you will see on your\n                  // screen for the pixel that is currently being processed.\n\nvoid main()\n{\n    out_Col = vec4(vec3(fs_Col), 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/terrain-frag.glsl
// module id = 79
// module chunks = 0